import { WIDGET_VIEW_I18N } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const I18nViewWidget: WidgetRegistryEntry = {
  name: WIDGET_VIEW_I18N,
  component: () => import("./i18n-view-widget.component").then((m) => m.I18nViewWidgetComponent)
};
